define(['lodash', 'edge/platform/tracking/EventHub', 'edge/platform/branding/BrandingData'], (_, EventHub, BrandingData) => () => {
    const payloadTransformers = [];
    const registry = {};
    const transformers = [];

    /**
     * A service allowing to wire various event adapters (such as Google Analytics or Segment.IO)
     * to events generated by the application using either a configuration
     * object or a simple DSL during the Angular's configure phase
     */
    const eventAdapter = {
        /**
         * Registers a handler for adapter optionally filtered by category,
         * eventName and a custom filter function
         */
        register({
            handler, category, eventName, filter, serviceName,
        }) {
            if (!_.isString(serviceName) || !_.isString(handler)) {
                throw new Error(`Either handler or serviceName are not strings. handler: ${handler}, serviceName: ${serviceName}`);
            }
            registry[serviceName] = registry[serviceName] || {};
            registry[serviceName][handler] = registry[serviceName][handler] || [];
            registry[serviceName][handler].push({
                filter,
                category: category || '*',
                eventName: eventName || '*',
            });

            return eventAdapter;
        },
        transform(transformFn) {
            // OOTB code
            console.log('DEPRECATED - Please use registerFunctionalHandler instead!'); //NOSONAR
            payloadTransformers.push(transformFn);
        },
        registerTransformer({source, target, transformer}) {
            transformers.push({source, target, transformer});
        },
        $get: ['$injector', 'applicationFeatures', ($injector, applicationFeatures) => {
            const hub = new EventHub();
            hub.eventTransformers = payloadTransformers;

            function loadAdapter(adapterName) {
                try {
                    return $injector.get(adapterName);
                } catch (error) {
                    if (error.message.match('Unknown provider')) {
                        throw new Error(`Event provider for '${adapterName}' is not registered.` +
                            ` Add a service called '${adapterName}'` +
                            ' before configuring tracking');
                    }
                    throw error;
                }
            }

            function wireAdapter(adapterConf, serviceName) {
                
                // Diego Cabero: This method have be enriched to allow different tracking features based on the channel.
                // features.json determinates what is available, including tracking.
                // We should be able to handle something like this in features.json:
                //
                // "tracking":{
                //     "tcs":{
                //         "googleAnalytics": "adapters.googleAnalytics"
                //     },
                //     "default":{
                //         "eTracker": "adapters.eTracker"
                //     }
                // }
                // 
                // With this example, tracking will enable only googleAnalytics for tcs channel and only eTracker by 
                // default (direct, probably).
                //
                
                function getAdapterName(nameOfService) {
                    let tracking = (applicationFeatures.tracking || {})[BrandingData.BRANDING];

                    if (!tracking) {
                        tracking = (applicationFeatures.tracking || {}).default;
                    }

                    return (tracking) ? tracking[nameOfService] : undefined;
                }

                function isEnabled(nameOfService) {
                    return !!(getAdapterName(nameOfService));
                }

                if (!isEnabled(serviceName)) {
                    return;
                }

                const adapter = loadAdapter(getAdapterName(serviceName));
                _.forEach(adapterConf, (handlerEventsConfig, handlerName) => {
                    const handler = adapter[handlerName];
                    _.forEach(handlerEventsConfig, ({ filter, category, eventName }) => {
                        hub.subscribe(category, eventName, (event) => {
                            if (!filter || filter(event)) {
                                handler(event);
                            }
                        });
                    });
                });
            }

            _.forEach(registry, wireAdapter);

            function wireTransformer({source, target, transformer}) {
                function publishToHub(payload) {
                    hub.publish(target.category, target.eventName, payload);
                }

                hub.subscribe(source.category, source.eventName, (event) => {
                    transformer(event.payload, publishToHub);
                });
            }

            transformers.forEach(wireTransformer);

            return hub;
        }],
    };
    return eventAdapter;
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/tracking/EventHubProvider.js